(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aboutproducts-slideshow"] && !window.DesignMode) return;
  try {
    
jQuery(function() {
$(document).on('shopify:section:select', function(){
THEME.initialization.mainSlider('.bnslider');
THEME.initialization.hoverColor();
THEME.initialization.setFullHeightSlider('.bnslider--fullheight');
})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aboutproducts-slideshow2"] && !window.DesignMode) return;
  try {
    
jQuery(function() {
$(document).on('shopify:section:select', function(){
THEME.initialization.mainSlider('.bnslider');
THEME.initialization.hoverColor();
THEME.initialization.setFullHeightSlider('.bnslider--fullheight');
})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aboutproducts-slideshow3"] && !window.DesignMode) return;
  try {
    
jQuery(function() {
$(document).on('shopify:section:select', function(){
THEME.initialization.mainSlider('.bnslider');
THEME.initialization.hoverColor();
THEME.initialization.setFullHeightSlider('.bnslider--fullheight');
})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aboutproducts-slideshow4"] && !window.DesignMode) return;
  try {
    
jQuery(function() {
$(document).on('shopify:section:select', function(){
THEME.initialization.mainSlider('.bnslider');
THEME.initialization.hoverColor();
THEME.initialization.setFullHeightSlider('.bnslider--fullheight');
})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aboutproducts-slideshow5"] && !window.DesignMode) return;
  try {
    
jQuery(function() {
$(document).on('shopify:section:select', function(){
THEME.initialization.mainSlider('.bnslider');
THEME.initialization.hoverColor();
THEME.initialization.setFullHeightSlider('.bnslider--fullheight');
})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    
jQuery(function() {
$(document).on('shopify:section:select', function(){
THEME.initialization.mainSlider('.bnslider');
THEME.initialization.hoverColor();
THEME.initialization.setFullHeightSlider('.bnslider--fullheight');
})
});

  } catch(e) { console.error(e); }
})();
})();
